import { IOption, ISubcategoryOption } from '../../interfaces/FormFields'
import { getYearImpots } from '../../services/utils'

export const ProfessionalCategory: IOption[] = [
  {
    value: '',
    label: 'Sélectionner',
  },
  {
    value: '1',
    label: 'ACTIF',
  },
  {
    value: '2',
    label: 'APPRENTI',
  },
  {
    value: '3',
    label: 'DEM.EMPLOI',
  },
  {
    value: '4',
    label: 'ELEVE/ETUDIANT',
  },
  {
    value: '5',
    label: 'INACTIF',
  },
  {
    value: '6',
    label: 'RETRAITE',
  },
]

export const ProfessionalSubcategories: ISubcategoryOption = {
  1: [
    {
      value: '',
      label: 'Sélectionner',
    },
    {
      value: '10',
      label: 'Agriculteur grande exploitation',
    },
    {
      value: '11',
      label: 'Agriculteur moyenne exploitation',
    },
    {
      value: '12',
      label: 'Agriculteur petite exploitation',
    },
    {
      value: '13',
      label: 'Agent public de la protection cat. C',
    },
    {
      value: '14',
      label: 'Artisan',
    },
    {
      value: '15',
      label: "Cadre administratif, commerce d'entreprise",
    },
    {
      value: '16',
      label: 'Cadre fonction publique cat. A',
    },
    {
      value: '17',
      label: 'Chauffeur',
    },
    {
      value: '18',
      label: "Chef d'entreprise",
    },
    {
      value: '19',
      label: 'Clergé',
    },
    {
      value: '20',
      label: 'Commerçant',
    },
    {
      value: '21',
      label: 'Contremaître, agent de maîtrise',
    },
    {
      value: '22',
      label: 'Employé administratif entreprise',
    },
    {
      value: '23',
      label: 'Employé civil fonction publique',
    },
    {
      value: '24',
      label: 'Employé de commerce',
    },
    {
      value: '25',
      label: "Ingénieur, cadre technique d'entreprise",
    },
    {
      value: '26',
      label: 'Instituteur et assimilés',
    },
    {
      value: '27',
      label: 'Ouvrier agricole',
    },
    {
      value: '28',
      label: 'Ouvrier non qualifié type artisanal',
    },
    {
      value: '29',
      label: 'Ouvrier non qualifié type industriel',
    },
    {
      value: '30',
      label: 'Ouvrier qualifié manutention, transport',
    },
    {
      value: '31',
      label: 'Ouvrier qualifié type artisanal',
    },
    {
      value: '32',
      label: 'Ouvrier qualifié type industriel',
    },
    {
      value: '33',
      label: 'Personnel service aux particuliers',
    },
    {
      value: '34',
      label: 'Profession intermédiaire de santé',
    },
    {
      value: '35',
      label:
        'Profession intermédiaire administrative, fonction publique cat. B',
    },
    {
      value: '36',
      label: 'Profession intermédiaire administrative commerce entreprise',
    },
    {
      value: '37',
      label: 'Professeur, scientifique',
    },
    {
      value: '38',
      label: 'Profession information, art',
    },
    {
      value: '39',
      label: 'Profession libérale',
    },
    {
      value: '40',
      label: 'Technicien',
    },
  ],
  2: [
    {
      value: '',
      label: 'Sélectionner',
    },
    {
      value: '41',
      label: 'Apprenti',
    },
  ],
  3: [
    {
      value: '',
      label: 'Sélectionner',
    },
    {
      value: '42',
      label: 'Demandeur d’emploi',
    },
  ],
  4: [
    {
      value: '',
      label: 'Sélectionner',
    },
    {
      value: '43',
      label: 'Elève, étudiant',
    },
  ],
  5: [
    {
      value: '',
      label: 'Sélectionner',
    },
    {
      value: '44',
      label: 'Personne sans profession',
    },
  ],
  6: [
    {
      value: '',
      label: 'Sélectionner',
    },
    {
      value: '45',
      label: 'Retraite',
    },
  ],
}

export const ActivityArea: IOption[] = [
  {
    value: '',
    label: 'Sélectionner',
  },
  {
    value: '8',
    label: 'ACT. SERV. ADMINISTR. SOUTIEN',
  },
  {
    value: '9',
    label: 'ACT. SPEC. SCIENTIFIQUES, TECHN.',
  },
  {
    value: '10',
    label: 'ADM. PUBLIQUE, EDUC., FORMATION',
  },
  {
    value: '11',
    label: 'AERONAUTIQUE',
  },
  {
    value: '12',
    label: 'AGROALIMENTAIRE',
  },
  {
    value: '13',
    label: 'ART, SPECTACLES, ACT. RECREATIVE',
  },
  {
    value: '14',
    label: 'AUDIOVISUEL',
  },
  {
    value: '15',
    label: 'AUTOMOBILE',
  },
  {
    value: '16',
    label: 'AUTRES ACT. DE SERVICES',
  },
  {
    value: '17',
    label: 'AUTRES ACT. EXTRA-TERRITORIALES',
  },
  {
    value: '18',
    label: 'AUTRES RETRAITES',
  },
  {
    value: '19',
    label: 'BANQUE, ASSURANCE, FINANCE',
  },
  {
    value: '1',
    label: 'BOIS, PAPIER, CARTON, IMPRIMERIE',
  },
  {
    value: '2',
    label: 'CHIMIE, PARACHIMIE',
  },
  {
    value: '3',
    label: 'COMM., DOCU., INFORM., MARKETING',
  },
  {
    value: '4',
    label: 'COMMERCE DE DETAIL',
  },
  {
    value: '5',
    label: "COMMERCE DE L'ART",
  },
  {
    value: '6',
    label: 'COMMERCE DU JEU',
  },
  {
    value: '20',
    label: 'DEFENSE, SECURITE',
  },
  {
    value: '7',
    label: 'ELECTRONIQUE, ELECTRICITE',
  },
  {
    value: '21',
    label: 'ENERGIE, ARMEMENT, MARCHES PUBL.',
  },
  {
    value: '22',
    label: 'ETUDES, CONSEIL',
  },
  {
    value: '23',
    label: 'ETUDIANTS LYCEENS',
  },
  {
    value: '24',
    label: 'GRANDE DISTRIBUTION',
  },
  {
    value: '25',
    label: 'IMMOBIL., BATIMENT, TRAVAUX PUB.',
  },
  {
    value: '26',
    label: 'INDUSTRIES EXTRACTIVES',
  },
  {
    value: '27',
    label: 'INFORMATIQUE',
  },
  {
    value: '28',
    label: 'JUSTICE',
  },
  {
    value: '29',
    label: 'MECANIQUE',
  },
  {
    value: '30',
    label: 'METALLURGIE',
  },
  {
    value: '31',
    label: 'NEGOCE, IMPORT EXPORT',
  },
  {
    value: '32',
    label: 'PROD. DISTRIB. EAU ASSAINISS.',
  },
  {
    value: '33',
    label: 'RESTAURATION, HEBERGEMENT',
  },
  {
    value: '34',
    label: 'SANS PROFESSION',
  },
  {
    value: '35',
    label: 'SANTE',
  },
  {
    value: '36',
    label: 'SPORT',
  },
  {
    value: '37',
    label: 'TELECOMMUNICATIONS',
  },
  {
    value: '38',
    label: 'TRANSPORT, LOGISTIQUE',
  },
]

export const IncomeType: IOption[] = [
  {
    value: '1',
    label: 'Professionnels',
  },
  {
    value: '2',
    label: 'Immobiliers',
  },
  {
    value: '3',
    label: 'Mobiliers',
  },
  {
    value: '5',
    label: 'Pensions alimentaires',
  },
  {
    value: '6',
    label: 'Autre',
  },
]

export const DocumentTypeByIncomeType: ISubcategoryOption = {
  1: [
    {
      value: '',
      label: 'Sélectionner',
    },
    {
      value: '1',
      label: 'Dernier avis d’imposition',
    },
    {
      value: '2',
      label: 'Dernier bulletin de salaire / retraite',
    },
  ],
  2: [
    {
      value: '1',
      label: 'Dernier avis d’imposition',
    },
  ],
  3: [
    {
      value: '1',
      label: 'Dernier avis d’imposition',
    },
  ],
  4: [
    {
      value: '3',
      label: 'Dernier justificatif (allocations familiales, RSA,…)',
    },
  ],
  5: [
    {
      value: '4',
      label: 'Attestation (jugement de divorce,…)',
    },
  ],
  6: [
    {
      value: '5',
      label: 'Justificatif à votre convenance',
    },
  ],
  7: [
    {
      value: '',
      label: 'Sélectionner',
    },
    {
      value: '1',
      label: 'Avis d’imposition / non imposition',
    },
  ],
}

export const DocumentTypeByIncomeTypeImpots: ISubcategoryOption = {
  2: [
    {
      value: '1',
      label: `Veuillez fournir votre avis d’impôt établi en ${new Date().getFullYear()} sur vos revenus ${getYearImpots()} (retrouvez ces informations en haut de la première page de votre avis d’impôt)`,
    },
  ],
  3: [
    {
      value: '1',
      label: `Veuillez fournir votre avis d’impôt établi en ${new Date().getFullYear()} sur vos revenus ${getYearImpots()} (retrouvez ces informations en haut de la première page de votre avis d’impôt)`,
    },
  ],
}
